import * as consts from '../constants';
import initialState from './initialState';

export default function customerReducer(state = initialState.customerState, action) {
    switch (action.type) {
        case consts.ACTONS.LOAD_CUSTOMERS_SUCCESS:
            return action.pagingModel;
        case consts.ACTONS.LOAD_CUSTOMERS_FAILED:
            return initialState.customerState;
        default:
            return state;
    }
}
